module.exports = __webpack_public_path__ + "static/img/12.f5c459b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/12.png
// module id = 3mbn
// module chunks = 0